module.exports = __webpack_public_path__ + "stylesheets/settings_2f980360c5f1f7d2d8541941a03cdeb6.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/settings.less
// module id = NGqW
// module chunks = 51